import { RemoteConfigNFC } from '../../../data/usecases/config-nfc/remote-config-nfc'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeConfigNFC = (stablismentId: number) => (
  new RemoteConfigNFC(`/stablishments/${stablismentId}/config-nfc`, makeAxiosHttpClient())
)
